import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '@/shared/lib/utils';

const BASE_TEXTAREA =
  'phx-input phx-textarea block w-full bg-phx-surface text-phx-text rounded-phx ' +
  'border border-phx-border-2 transition-[border-color,box-shadow] ' +
  'placeholder:text-phx-text-faint resize-y ' +
  'py-phx-3 px-phx-4 leading-[1.45] text-phx-md ' +
  'hover:border-phx-border-3 ' +
  'focus:outline-none focus:border-phx-primary focus:shadow-phx-focus ' +
  'disabled:bg-phx-surface-3 disabled:text-phx-text-muted disabled:cursor-not-allowed';

const REQUIRED_BG = 'bg-phx-required-tint focus:bg-phx-surface';
const DRAFT_BG = 'bg-phx-draft-tint';
const INVALID_RING =
  'border-phx-danger focus:border-phx-danger focus:shadow-[0_0_0_2px_rgba(181,52,42,0.25)]';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  draft?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { rows = 3, invalid, draft, required, className, ...rest },
  ref
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      data-invalid={invalid ? '' : undefined}
      data-draft={draft ? '' : undefined}
      required={required}
      className={cn(
        BASE_TEXTAREA,
        required && REQUIRED_BG,
        draft && DRAFT_BG,
        invalid && INVALID_RING,
        className
      )}
      {...rest}
    />
  );
});
